<template>
  <div>
    <div
      :data-version="$store.getters.appVersion"
      class="container"
      :class="{ 'login-new': isLoginPage }"
    >
      <alert-container />
      <mbe-empty-topbar />

      <div :class="{ row: true }">
        <!-- Div router-view -->
        <div
          class="col-12 divrouter"
          :class="{ 'col-12 no-padding': isLoginPage }"
        >
          <slot></slot>
        </div>
        <!-- Div space -->
        <div class="invisible col-1 d-none d-xl-block" />
      </div>
    </div>
    <vue-snotify />
    <loading
      :event-bus="myEventBus"
      event-show="show-my-full-loading"
      event-hide="hide-my-full-loading"
      :label="$t('loading')"
    />
    <div id="modal_container" />
  </div>
</template>

<script>
import Vue from "vue";
import Navbar from "@components/controls/Navbar.vue";
import EmptyTopbar from "@components/controls/EmptyTopbar.vue";
import { Component } from "vue-property-decorator";
import { VersionCheckService } from "@/services/VersionCheckService";
import { EventBus } from "@/event-bus";
import loading from "vue-full-loading";

@Component({
  components: {
    MbeNavbar: Navbar,
    MbeEmptyTopbar: EmptyTopbar,
    loading
  }
})
export default class UUIDLayout extends Vue {
  checkVersionService = VersionCheckService;

  myEventBus = EventBus;

  constructor() {
    super();
    this.checkVersionService = new VersionCheckService();
    EventBus.$on("to-modal", function(content) {
      // TODO: EventBus event is called 4 or 5 times (also in event-bus.ts)
      // this code allows no errors by checking if modal_container exists
      // even when receiving this event several times
      const div = document.getElementById("modal_container");
      if (div !== null) {
        content.$mount("#modal_container");
      }
    });
    EventBus.$on("out-of-modal", function(content) {
      const Empty = Vue.extend({
        template: '<div id="modal_container"></div>'
      });
      const empty = new Empty();
      empty.$mount(".mbe-modal-mask");
    });
  }

  created() {
    const titlePrefix = this.$store.getters.envs.envLabel
      ? this.$store.getters.envs.envLabel + " "
      : "";
    document.title = titlePrefix + "MBE OnLine";
  }

  // Hide topbar and navbar
  get isLoginPage() {
    return this.$route.path === "/login";
  }
}
</script>

<style lang="scss">
@import "../index";

.container {
  margin-right: 0px !important;
  margin-left: 0px !important;
  max-width: none !important;
  display: flex;
  justify-content: center;
}

.container > .row {
  width: 100%;
}

.container > .row > .divrouter {
  padding-top: 75px;
  padding-bottom: 40px;
}

.container.login > .row > .divrouter {
  padding-top: 0px;
}

.container.login-new {
  padding: 0;
  margin: 0;
}

.container > .row.breadcrumb-shown > .login-new {
  padding: 0;
  width: 100%;
}

.container > .row.breadcrumb-shown > .divrouter {
  padding-top: 175px;
}

.container > .row.breadcrumb-shown > .divrouter .maindiv {
  margin-top: -86px;
  width: 100%;
  padding-right: 125px;
}

.divnavbar {
  z-index: 10;
}

.maindiv {
  position: fixed;
  margin-top: 89px;
  z-index: 1;
}
</style>
